import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('campaigns');
    }

    offersByTSP (id) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/campaigns/${id}/tsp`,
        });
    }

    splitterList (campaignId, params = {}) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/campaigns/${campaignId}/splitter`,
            params: params,
        });
    }

    triggerList (campaignId, params = {}) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/campaigns/${campaignId}/triggers`,
            params: params,
        });
    }

    payouts (campaignId, params = {}) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/campaigns/${campaignId}/payouts`,
            params: params,
        });
    }

    possibleTriggersList (params = {}) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/campaigns/l-triggers',
            params: params,
        });
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v1/dict/campaigns',
            params: params,
        });
    }

    createRTBCampaign (campaignId, data) {
        return this.client.request ({
            method: 'post',
            path: `/publisher/v1/campaigns/${campaignId}/rtb`,
            data: data,
        });
    }

    activate (campaignId) {
        return this.client.request ({
            method: 'put',
            path: `/publisher/v1/campaigns/${campaignId}/unpause`,
        });
    }

    pause (campaignId) {
        return this.client.request ({
            method: 'put',
            path: `/publisher/v1/campaigns/${campaignId}/pause`,
        });
    }

    saveClicktag (campaignId, data) {
        return this.client.request ({
            method: 'put',
            path: `/publisher/v1/campaigns/${campaignId}/save-clicktag`,
            data: data,
        });
    }
}

export default new Resource;
